/* eslint-disable eqeqeq */
export const validateCPF = cpf => {
  let sum
  let rest
  sum = 0
  cpf = cpf.replace(/[^\d]+/g, '')
  if (cpf === '') return false
  if (cpf.length !== 11) return false
  if (cpf === '00000000000') return false
  for (let i = 1; i <= 9; i++) {
    sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i)
  }
  rest = (sum * 10) % 11
  if (rest === 10 || rest === 11) rest = 0
  if (rest !== parseInt(cpf.substring(9, 10))) return false
  sum = 0
  for (let i = 1; i <= 10; i++) {
    sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i)
  }
  rest = (sum * 10) % 11
  if (rest === 10 || rest === 11) rest = 0
  if (rest !== parseInt(cpf.substring(10, 11))) return false
  return true
}

export const validateCNPJ = cnpj => {
  let b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

  if ((cnpj = cnpj.replace(/[^\d]/g, '')).length != 14) return false

  if (/0{14}/.test(cnpj)) return false

  let n = 0
  for (let i = 0; i < 12; n += cnpj[i] * b[++i]);
  if (cnpj[12] != (((n %= 11) < 2) ? 0 : 11 - n)) return false

  n = 0
  for (let i = 0; i <= 12; n += cnpj[i] * b[i++]);
  if (cnpj[13] != (((n %= 11) < 2) ? 0 : 11 - n)) return false

  return true
}

export const validateDocument = document =>
  validateCPF(document) || validateCNPJ(document)



// WEBPACK FOOTER //
// ./src/utils/documentValidation.js